<template>
	<fieldset class="destination_fieldset">
		<legend>{{ language.destinationLegend }}</legend>

		<div class="form-row form-row--wide form-row--visible" v-bind:class="{cancellable: isCancellable}">
			<div class="form-field" data-icon="pin" v-click-outside="hideDestinationDropdown">
				<input type="hidden" name="destination" :value="destination ? destination.id : 0">
				<label for="destination_search" id="bookingform__destination__label">{{ language.destination }}</label>
				<input type="text" ref="destinationSearch" :class="{'focus': destinationDropdownOpen}" name="destination_search"  id="destination_search" :placeholder="placeholder" autocomplete="off" v-model="destinationSearch" @keyup="filterResults" @click="openDestinationDropdown" @keydown.enter.prevent="openDestinationDropdown" @keydown.down.prevent="keyDownHandler" @keydown.space="openDestinationDropdown" @keydown.escape="hideDestinationDropdown" @focus="onFocus">

				<div :class="destinationDropdownOpen ? 'input-dropdown open' : 'input-dropdown'" v-if="destinationDropdownOpen" @keydown="keyDownHandler">
					<div class="input-dropdown__segment input-dropdown__segment--cols" v-if="visibleDestinations.length == 0 && visibleHotels.length == 0">
						<header>{{ language.noDestinations }}</header>
					</div>

					<div class="input-dropdown__segment input-dropdown__segment--cols" v-if="visibleDestinations.length > 0">
						<header>
							{{ language.popularDestinations }}
						</header>
						<ul>
							<li v-for="destination in visibleDestinations" :key="destination.id">
								<a :href="'#' + sanitizeString(destination.name + '_' + destination.id)" v-html="destination.name" @click.prevent="selectDestination(destination.id)" @keydown.tab=selectDestination(destination.id) @keydown.enter=selectDestination(destination.id) v-if="!destination.inactive"></a>
								<a v-html="destination.name" class="inactive" v-if="destination.inactive"></a>
							</li>
						</ul>
					</div>
					<div class="input-dropdown__segment" v-if="visibleHotels.length > 0">
						<header>
							{{ language.hotels }}
						</header>
						<ul>
							<li v-for="hotel in visibleHotels" :key="hotel.id">
								<a :href="'#' + sanitizeString(hotel.name + '_' + hotel.id)" v-html="hotel.name" @click.prevent=selectDestination(hotel.id) @keydown.tab=selectDestination(hotel.id) @keydown.enter	=selectDestination(hotel.id) v-if="!hotel.inactive"></a>
								<a v-html="hotel.name" class="inactive" v-if="hotel.inactive"></a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class="cancelButton" v-if="isCancellable" @click="selectDestination()"></div>
		</div>
	</fieldset>
</template>

<script>
import ClickOutside from 'vue-click-outside'

export default {
	name: 'Destination',

	data: function(){
		return {
			destinationSearch: '',
			destinationDropdownOpen: false,
		}
	},
	computed: {
		placeholder: function (){
			return window.innerWidth <= 768 ? this.language.destinationPHShort : this.language.destinationPH
		},
		language: function() {
			return this.$store.state.language
		},

		isCancellable: function(){
			return this.destination
		},

		destination: function() {
			return this.$store.state.destination
		},
		destinations: function() {
			return this.$store.state.destinations
		},
		visibleDestinations: function(){
			const vDest = []
			this.destinations.map(dest => {
				if(
					(this.$store.state.where == dest.id)
					||
					(!dest.invisible && vDest.length < 6)
				){
					vDest.push(dest)
				}
			})
			return vDest
		},
		hotels: function() {
			return this.$store.state.hotels
		},
		visibleHotels: function(){
			return this.hotels.filter(dest => {
				return !dest.invisible
			})
		},
		sanitizeString: function(){
			return this.$root.sanitizeString
		},
		clearTags: function(){
			return this.$root.clearTags
		}
	},
	methods: {

		onFocus() {
			if(!this.destinationDropdownOpen && window.innerWidth < this.$store.state.mobileBreakpoint) {
				this.$nextTick(function(){
					document.getElementById('destination_search').blur()
				})
				//console.log(this.$refs.destinationSearch.blur())
			}
			this.$emit('focus')
		},

		filterResults(e){
			// enter "enter"
			if(e.code == 'Enter'){
				// todo: quickly set the appropriate destination
			}
			//open the dropdown if not already open on key strokes that are not "tab" or "shift"

			e.code == 'Tab' || e.key == 'Shift' || this.destinationDropdownOpen || this.openDestinationDropdown()

			this.$store.dispatch('filterDestinations', this.destinationSearch)
			this.$store.dispatch('filterHotels', this.destinationSearch)
		},

		openDestinationDropdown() {
			console.log(this.$store.destination)
			this.destinationDropdownOpen = true
			this.$emit('opened')
		},
		hideDestinationDropdown() {

			// remove search when closing and none selected
			if(this.destinationDropdownOpen && this.destinationSearch !== '' && !this.$store.destination){
				this.destinationSearch = ''
				this.$store.dispatch('filterDestinations', this.destinationSearch)
				this.$store.dispatch('filterHotels', this.destinationSearch)
			}

			this.destinationDropdownOpen = false
			this.$emit('closed')

		},

		selectDestinationSearch() {
			this.$refs.destinationSearch.select()
		},

		selectDestination(destination){
			this.$store.dispatch('selectDestination', destination)
			this.destinationDropdownOpen = false
			this.$emit('selectDestination')
		},

		keyDownHandler(e){
			if(e.key == 'Tab'){
				this.hideDestinationDropdown();
			}
			else if(e.key == 'Escape'){
				this.$refs.destinationSearch.focus()
			}
			else {
				if(e.key == 'ArrowDown'){
					// next
					this.focusNextItem(e)
				}
				if(e.key == 'ArrowUp'){
					// prev
					this.focusPrevItem(e)
				}
			}
		},

		focusNextItem(e){
			const eventTarget = e.target;
			let nextItem = eventTarget.parentNode.nextElementSibling || null;

			// When key down happens in initial input field
			if(e.target === this.$refs.destinationSearch){
				nextItem = eventTarget.nextElementSibling;
			}
			else if (!nextItem) {
				nextItem = eventTarget.parentNode.parentNode.parentNode.nextElementSibling || eventTarget.parentNode.parentNode.parentNode.previousElementSibling;
			}

			// Select first a in nextItem
			if(nextItem) nextItem.querySelector('a').focus();
		},

		focusPrevItem(e){

			// When key down happens in initial input field do nothing
			if(e.target === this.$refs.destinationSearch) return;

			const eventTarget = e.target;
			let nextItem = eventTarget.parentNode.previousElementSibling;
			if(!nextItem){
				nextItem = eventTarget.parentNode.parentNode.parentNode.previousElementSibling || eventTarget.parentNode.parentNode.parentNode.nextElementSibling;
			}
			// Select first a in nextItem
			if(nextItem) {
				const as = nextItem.querySelectorAll('a')
				as[as.length - 1].focus();
			}
		},
	},

	watch: {
		destination: function() {
			if(this.destination == null) {
				this.destinationSearch = ''
				this.$emit('error', 'destionation_destination_notavailable')
			} else {
				if (this.destination.name) {
					this.destinationSearch = this.clearTags(this.destination.name)
				}
			}
		},
	},

	// do not forget this section
	directives: {
		ClickOutside
	}
}
</script>